import Card from "./common/Card";
import SectionTitle from "./common/SectionTitle";

const teamMembers = [
	{
		id: 1,
		name: "Martin Atsegbua",
		role: "CEO & Founder",
		image: "male-thumbnail.webp",
		social: {
			linkedin: "#",
			twitter: "#",
		},
	},
	{
		id: 2,
		name: "Tosin Sosan",
		role: "CFO",
		image: "female-thumbnail.png",
		social: {
			linkedin: "#",
			twitter: "#",
		},
	},
	{
		id: 3,
		name: "Robert Garcia",
		role: "Lead Developer",
		image: "male-thumbnail.webp",
		social: {
			linkedin: "#",
			twitter: "#",
		},
	},
	{
		id: 4,
		name: "Amanda Smith",
		role: "Business Executive",
		image: "female-thumbnail.png",
		social: {
			linkedin: "#",
			twitter: "#",
		},
	},
];

const Team = () => {
	return (
		<section className="team">
			<div className="container flex flex-col ">
				<SectionTitle
					title="Our Team"
					subtitle="Meet the experts behind Trivnet"
				/>

				<div className="w-full team-grid">
					{teamMembers.map((member) => (
						<Card key={member.id} className="team-member">
							<div className="member-image">
								<img
									src={`/assets/images/team/${member.image}`}
									alt={member.name}
								/>
								<div className="social-links">
									<a
										href={member.social.linkedin}
										target="_blank"
										rel="noopener noreferrer"
									>
										<i className="fab fa-linkedin-in"></i>
									</a>
									<a
										href={member.social.twitter}
										target="_blank"
										rel="noopener noreferrer"
									>
										<i className="fab fa-twitter"></i>
									</a>
								</div>
							</div>
							<div className="member-info">
								<h3>{member.name}</h3>
								<p>{member.role}</p>
							</div>
						</Card>
					))}
				</div>
			</div>
		</section>
	);
};

export default Team;
